import type { SVGProps } from 'react';

export const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 14' fill='none' {...props}>
    <path
      d='M14.0351 7.01754C14.0351 3.14386 10.8912 0 7.01754 0C3.14386 0 0 3.14386 0 7.01754C0 10.414 2.41404 13.2421 5.61404 13.8947V9.12281H4.21053V7.01754H5.61404V5.26316C5.61404 3.90877 6.71579 2.80702 8.07018 2.80702H9.82456V4.91228H8.42105C8.03509 4.91228 7.7193 5.22807 7.7193 5.61403V7.01754H9.82456V9.12281H7.7193V14C11.2632 13.6491 14.0351 10.6596 14.0351 7.01754Z'
      fill='black'
    />
  </svg>
);
